import { render, staticRenderFns } from "./salesAnalysis.vue?vue&type=template&id=866b8e3e"
import script from "./salesAnalysis.vue?vue&type=script&lang=js"
export * from "./salesAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports